<div fxFlex="column" class="grade-dialog">
  <div class="dialog-header">
    {{ title }}
    <span class="right" (click)="onCancel()">x</span>
  </div>
  <div class="grade-container" fxLayout="column">
    <div class="background-white pd-30">
      
      <mat-tab-group>
        <mat-tab label="Lesson Attempts">
          <div fxLayout="row" fxLayoutAlign="space-between">
            <div class="sub-header">Attempt Details</div>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-between">
            <table class="table-border" *ngIf="curriculumViewDetail?.Attempts">
              <thead>
                <th class="grade-attempt">Grade</th>
                <th class="status">Status</th>
                <th class="date-attempt">Complete Date</th>
                <!-- <th class="report-attempt" *ngIf="curriculumViewDetail?.IsDiagnosticExam && curriculumViewDetail?.Attempts">Report</th> -->
                <th class="action-attempt"></th>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    let aData of curriculumViewDetail?.Attempts
                      | orderBy: 'Sequence':'asc';
                    let i = index
                  "
                >
                  <td class="grade-attempt"
                  [class.red-grade]="checkForRedGrade(aData?.Grade)"
                  [class.green-grade]="checkForGreenGrade(aData?.Grade)"
                  >
                    {{ aData?.Grade ?aData?.Grade + "%" : "N/A" }}
                  </td>
                  <td class="status">{{ aData?.Status || "" }}</td>
                  <td class="date-attempt">{{ aData?.CompleteDate || "N/A" }}</td>
                  <!-- <td 
                  class="report-attempt"
                  *ngIf="curriculumViewDetail?.IsDiagnosticExam && curriculumViewDetail?.Attempts">
                    <button 
                        class="button secondary-button report-attempt-button"
                        (click)="onCancel()"
                        [routerLink]="['/ELearning/CurriculumDiagnosticReport/' + curriculumViewDetail?.StudentConsumerCurriculumID]">
                          Click Here
                    </button>
                  </td> -->
                  <td class="action-attempt">
                    <a
                      href="javascript:void(0)"
                      *ngIf="aData?.Status == 'Complete'"
                      (click)="redirectToViewWorkFromAttempt(aData)"
                      >View Work</a
                    >
                  </td>
                  
                </tr>
              </tbody>
            </table>

            <div *ngIf="!curriculumViewDetail?.Attempts">
              There are currently no attempts.
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Standards">
          <br><br>

          <div *ngIf="!curriculumItemStandards">
            There are no standards associated with this lesson.
          </div>


          <div *ngFor="let standard of curriculumItemStandards">
              <mat-card>
                <mat-card-title>
                  <div 
                    *ngIf="standard.NeedsAttention"
                    class="suggested">
                  Suggested
                </div>
                  {{standard.StandardName}}
                </mat-card-title>
                <mat-card-content>
                    {{standard.StandardDescription}}
                </mat-card-content>
              </mat-card>
            </div>
        </mat-tab>
      </mat-tab-group>

      
      
      <div class="button-container" fxLayout="row" fxLayoutAlign="flex-end">
        <button 
            class="button secondary-button card-button-report"
            *ngIf="curriculumViewDetail?.IsDiagnosticExam && curriculumViewDetail?.Attempts"
            (click)="onCancel()"
            [routerLink]="['/ELearning/CurriculumDiagnosticReport/' + curriculumViewDetail?.StudentConsumerCurriculumID]">
              Show Free Diagnostic Report 
        </button>
        <button
          class="button card-button primary-button"
          mat-button
          type="button"
          (click)="onCancel()"
        >
          Okay
        </button>
      </div>
    </div>
  </div>
</div>
